// « Photo Vivante » in the PRINTED book (2026-11-03). When an album's living
// photo is ready (worker routes/living.ts), its print gets:
//   • the still as the book's very last page (full bleed) — pdfGenerator
//     generateInteriorPdf, after the ÷4 padding, so the QR on the back cover
//     sits right next to the photo it plays;
//   • the QR + « Scannez-moi : votre souvenir prend vie » on the back cover —
//     generateCoverPdf.
// Both halves' render hashes carry `livingHashInput`, so making it ready (or
// replacing the video's still) re-renders the album instead of being skipped
// as « unchanged ». No living photo → no field → every hash as before.
import { livingApi, type LivingItem } from './api';

// A living photo on a photo ALREADY in the album (`photo_id`, 2026-11-04)
// prints nothing new: no last page, only the QR on the back cover.
export interface LivingPrint { stillUrl: string | null; link: string; hash: { link: string; at: string } }

/** The printable living photo of one album, or null. Never throws. */
export async function livingPrintFor(shopifyOrderId: string, albumIndex: number): Promise<LivingPrint | null> {
  try {
    const { items } = await livingApi.forOrder(shopifyOrderId);
    return livingPrintFromItems(items, albumIndex);
  } catch {
    return null;
  }
}

/** Pure part: pick the ready row of this album. */
export function livingPrintFromItems(items: readonly LivingItem[], albumIndex: number): LivingPrint | null {
  const it = items.find((i) => i.album_index === albumIndex && i.status === 'ready' && !!i.still_url);
  if (!it || !it.still_url) return null;
  return { stillUrl: it.photo_id ? null : it.still_url, link: it.link, hash: { link: it.link, at: it.updated_at } };
}

export { LIVING_BACK_TEXT } from './livingText';
